import React from 'react';
import Popup from 'reactjs-popup';
import { VDCover } from '../../images';
import './GeneralPopup.css';

const GeneralPopup = (props) => {
	const { showPopup, onCloseClick } = props;

	return (
		<Popup
			open={showPopup}
			closeOnDocumentClick
			position="top center"
			contentStyle={{ width: '80%', height: 'auto', maxWidth: 600 }}
		>
			<div className="PopupContainer">
				<a
					className="close"
					onClick={onCloseClick}
				>
					&times;
				</a>
				<div className="PopupContainerContent">
					<h2 className="PopupContainerTitle">
						Important Notice
					</h2>
					<div className="PopupContainerDesc">
						Guarantee delivery time for Valentine’s Day period (Feb. 12-14) is between 9am and 4pm, but ASAP
					</div>
				</div>
				{/* <img
					alt="VDCover"
					className="PopupImage"
					src={VDCover}
				/> */}
			</div>

		</Popup>
	);
};

export default GeneralPopup;



// WEBPACK FOOTER //
// ./src/components/PopupComponent/GeneralPopup.jsx